import {Gear, Link, Star, User} from '@phosphor-icons/react';
import {messages} from '@smartmixin/i18n';
import React from 'react';
import {useIntl} from 'react-intl';
import type {NavItem} from '../../layout/useNavItems';

export type SettingsSection = NavItem & {
  /** One-line summary under the label on the phone index. */
  description?: string;
};

const under = (path: string) => (p: string) =>
  p === path || p.startsWith(`${path}/`);

/**
 * The settings sections, in order: the phone index rows and the ≥900 side
 * list. Each claims its sub-pages too (premium/success, services/<provider>),
 * so exactly one is current on any settings page but the index.
 */
export const useSettingsSections = (): SettingsSection[] => {
  const {formatMessage} = useIntl();
  return React.useMemo(
    () => [
      {
        key: 'account',
        label: formatMessage(messages.account.account),
        description: formatMessage(messages.account.accountDescription),
        icon: <User />,
        to: '/app/settings/account',
        isActive: under('/app/settings/account'),
      },
      {
        key: 'premium',
        label: formatMessage(messages.premium.premium),
        icon: <Star />,
        to: '/app/settings/premium',
        isActive: under('/app/settings/premium'),
      },
      {
        key: 'preferences',
        label: formatMessage(messages.settings.preferencesSection),
        icon: <Gear />,
        to: '/app/settings/preferences',
        isActive: under('/app/settings/preferences'),
      },
      {
        key: 'services',
        label: formatMessage(messages.addons.weatherServices),
        description: formatMessage(messages.addons.weatherServicesDescription),
        icon: <Link />,
        to: '/app/settings/services',
        isActive: under('/app/settings/services'),
      },
    ],
    [formatMessage],
  );
};
